module.exports = __webpack_public_path__ + "static/media/emp.a3c7c688.jpg";